// extracted by mini-css-extract-plugin
module.exports = {"sort":"AdminTable_sort__1PF0u","tableStyle":"AdminTable_tableStyle__3uta9","tableHeader":"AdminTable_tableHeader__1pQ_e"};